export enum HasuraRole {
  USER = 'user',
  OWNER = 'owner',
  REGIONAL_EDITOR = 'regional-editor',
  MANAGING_EDITOR = 'managing-editor',
  TRANSLATOR = 'translator',
}
